export default "__VITE_ASSET__BvfAQBfE__"